import { render, staticRenderFns } from "./InvProfit.vue?vue&type=template&id=76fce04d"
import script from "./InvProfit.vue?vue&type=script&lang=js"
export * from "./InvProfit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports